<template>
  <div>
    <a-form layout="inline">
      <a-form-item>
        <a-date-picker v-model="startDate" @change="onStartDate" class="margenEstilosDashboard" />
      </a-form-item>
      <a-form-item>
        <a-date-picker v-model="endDate" @change="onEndDate" class="margenEstilosDashboard"/>
      </a-form-item>
      <a-form-item>
        <a-input v-model="dni" class="margenEstilosDashboard" placeholder="Buscar por DNI"/>
      </a-form-item>
      <br>
      <a-form-item>
        <a-button class="margenEstilosDashboard" @click="loadData">Consultar</a-button>
        <a-button class="margenEstilosDashboard" @click="exportXLSX">Exportar</a-button>
      </a-form-item>
    </a-form>
    <ag-grid-vue style="height: 400px;" class="ag-theme-balham"
      :gridOptions="gridOptions"
      :defaultColDef="defaultColumnDefs"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :pagination="true">
    </ag-grid-vue>
  </div>
</template>

<script>
/* eslint-disable eol-last */

import { mapGetters } from 'vuex'
import modulesType from '@/store/types/modules'
import authType from '@/store/types/auth'
import moment from 'moment'
// import { TreeSelect } from 'ant-design-vue'
import { AgGridVue } from 'ag-grid-vue'

const columns = [
  {
    headerName: 'ITEM',
    sortable: true,
    field: 'id',
    width: 60,
  }, {
    headerName: 'RESULTADO',
    sortable: true,
    field: 'esApto',
    width: 100,
  }, {
    headerName: 'FECHA DE REGISTRO',
    sortable: true,
    field: 'fechaRegistro',
    width: 140,
  }, {
    headerName: 'NUM. DOCUMENTO',
    sortable: true,
    field: 'numDocumento',
    width: 90,
  }, {
    headerName: 'NOMBRES',
    sortable: true,
    field: 'nombres',
    width: 180,
  }, {
    headerName: 'TELEFONO',
    sortable: true,
    field: 'telefono',
    width: 100,
  }, {
    headerName: 'CORREO',
    sortable: true,
    field: 'correo',
    width: 160,
  }, {
    headerName: 'ESTADO CIVIL',
    sortable: true,
    field: 'estadoCivil',
    width: 100,
  }, {
    headerName: 'CONYUGE',
    sortable: true,
    field: 'dniConyuge',
    width: 90,
  }, {
    headerName: 'DEPARTAMENTO',
    sortable: true,
    field: 'nombreDepartamento',
    width: 150,
  }, {
    headerName: 'PROVINCIA',
    sortable: true,
    field: 'provincia',
    width: 150,
  }, {
    headerName: 'DISTRITO',
    sortable: true,
    field: 'distrito',
    width: 150,
  }, {
    headerName: 'DIRECCIÓN',
    sortable: true,
    field: 'direccion',
    width: 150,
  }, {
    headerName: 'TIPO DE VIVIENDA',
    sortable: true,
    field: 'tipoVivienda',
    width: 150,
  }, {
    headerName: 'T. VIV. DETALLE',
    sortable: true,
    field: 'tipoViviendaDetalle',
    width: 150,
  }, {
    headerName: 'CONDICION LABORAL',
    sortable: true,
    field: 'condicionLaboral',
    width: 150,
  }, {
    headerName: 'INGR. MENSUAL / VT. MENSUAL',
    sortable: true,
    field: 'ingresoBrutoMensual',
    width: 140,
  }, {
    headerName: 'MONEDA',
    sortable: true,
    field: 'moneda',
    width: 140,
  }, {
    headerName: 'MONTO SOLICITADO',
    sortable: true,
    field: 'montoSolicitado',
    width: 140,
  }, {
    headerName: 'PLAZO SOLICITADO',
    sortable: true,
    field: 'plazo',
    width: 140,
  }, {
    headerName: 'TIPO DE PRESTAMO',
    sortable: true,
    field: 'tipoPrestamo',
    width: 140,
  }, {
    headerName: 'RUC',
    sortable: true,
    field: 'ruc',
    width: 140,
  }, {
    headerName: 'RAZON SOCIAL',
    sortable: true,
    field: 'razonSocial',
    width: 140,
  }, {
    headerName: 'TIPO DE NEGOCIO',
    sortable: true,
    field: 'tipoDeNegocio',
    width: 140,
  }, {
    headerName: 'SCORE',
    sortable: true,
    field: 'scoreSentinel',
    width: 140,
  },
  {
    headerName: 'AGENCIA',
    sortable: true,
    field: 'agenciaAtencion',
    width: 140,
  },
  {
    headerName: 'CREDITO DESTINO',
    sortable: true,
    field: 'creditoDestino',
    width: 140,
  },
  {
    headerName: 'TIPO DE PRODUCTO',
    sortable: true,
    field: 'tipoDeProducto',
    width: 140,
  },
  {
    headerName: 'AVISO RUC',
    sortable: true,
    field: 'avisoRUC',
    width: 140,
  },
  {
    headerName: 'MOTIVO',
    sortable: true,
    field: 'motivoResultado',
    width: 200,
  },
]

export default {
  dependencies: ['DynamicCallService', 'GenericService'],
  name: 'Module',
  components: {
    AgGridVue,
  },
  data() {
    return {
      gridOptions: null,
      client: '',
      dni: '',
      rowData: null,
      columnDefs: null,
      startDate: moment(),
      fechaInicio: moment().format('YYYY-MM-DD'),
      endDate: moment(),
      selectedTo: moment().format('YYYY-MM-DD'),
      size: 'default',
      selectedProvinces: [],
    }
  },
  computed: {
    ...mapGetters({
      // endpointForList: modulesType.getters.get ,
      // endpointForExport: modulesType.getters.getEndpointForExport,
      user: authType.getters.getUser,
    }),
  },
  created() {
    this.setModule()
  },
  beforeMount() {
    this.gridOptions = {}
    this.columnDefs = columns
    this.defaultColumnDefs = {
      resizable: true,
    }
    // console.log('USER', this.user.id)
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi
    this.loadData()
  },
  watch: {
    $route: 'setModule',
  },
  methods: {
    handleChange(value) {
      this.selectedProvinces = value
    },
    // moment,
    async setModule() {
      await this.$store.dispatch(modulesType.actions.setModule, {
        key: this.$route.params.key,
      })
    },
    async loadData() {
      try {
        this.gridApi.showLoadingOverlay()
        const data = await this.GenericService.get(`webmarketplace/list-sanmartin-reports?fechaInicio=${this.fechaInicio}&fechaFin=${this.selectedTo}&numDocumento=${this.dni}&userId=${this.user.id}`)
        if (data) {
          this.rowData = data
        } else {
          this.$notification.warning({
            message: 'Error',
            description: 'No hay registros en las fechas seleccionadas',
          })
          this.rowData = null
        }
      } catch (err) {
        this.$notification.warning({
          message: 'ERROR',
          description: err.message,
        })
      } finally {
        this.gridApi.hideOverlay()
      }
    },
    async exportXLSX() {
      const tkn = this.GenericService.axios.defaults.headers.common.Authorization.substring(7)
      window.open(`${process.env.VUE_APP_API_URL}/webmarketplace/download-sanmartin-reports?tkn=${tkn}&fechaInicio=${this.fechaInicio}&fechaFin=${this.selectedTo}&numDocumento=${this.dni}&userId=${this.user.id}`, '_blank')
    },
    onStartDate(date, dateString) {
      // console.log(dateString, 'fechaInicio')
      this.fechaInicio = dateString
      // console.log(this.fechaInicio, 'this.fechaInicio')
    },
    onEndDate(date, dateString) {
      // console.log(dateString, 'fechaFin')
      this.selectedTo = dateString
      // console.log(this.selectedTo, 'this.selectedTo')
    },
  },
}

</script>
